var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeblank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.252 18.192C11.516 18.192 10.8493 18.064 10.252 17.808C9.65467 17.5413 9.17467 17.136 8.812 16.592C8.44933 16.048 8.25733 15.3653 8.236 14.544H10.252C10.2627 15.088 10.4387 15.5467 10.78 15.92C11.132 16.2827 11.6227 16.464 12.252 16.464C12.8493 16.464 13.308 16.2987 13.628 15.968C13.948 15.6373 14.108 15.2213 14.108 14.72C14.108 14.1333 13.8947 13.6907 13.468 13.392C13.052 13.0827 12.5133 12.928 11.852 12.928H11.02V11.248H11.868C12.412 11.248 12.8653 11.12 13.228 10.864C13.5907 10.608 13.772 10.2293 13.772 9.728C13.772 9.312 13.6333 8.98133 13.356 8.736C13.0893 8.48 12.716 8.352 12.236 8.352C11.7133 8.352 11.3027 8.50667 11.004 8.816C10.716 9.12533 10.556 9.504 10.524 9.952H8.524C8.56667 8.91733 8.924 8.10133 9.596 7.504C10.2787 6.90667 11.1587 6.608 12.236 6.608C13.004 6.608 13.6493 6.74667 14.172 7.024C14.7053 7.29067 15.1053 7.648 15.372 8.096C15.6493 8.544 15.788 9.04 15.788 9.584C15.788 10.2133 15.612 10.7467 15.26 11.184C14.9187 11.6107 14.492 11.8987 13.98 12.048C14.6093 12.176 15.1213 12.4853 15.516 12.976C15.9107 13.456 16.108 14.064 16.108 14.8C16.108 15.4187 15.9587 15.984 15.66 16.496C15.3613 17.008 14.924 17.4187 14.348 17.728C13.7827 18.0373 13.084 18.192 12.252 18.192Z",
    fill: "#366EE3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#366EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeblank);
export default __webpack_public_path__ + "static/media/threeblank.ba6061192b7b0ca47c21049db4b14d52.svg";
export { ForwardRef as ReactComponent };